"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7959],{

/***/ 18778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ty": function() { return /* binding */ DashboardIntervalValues; },
/* harmony export */   "f_": function() { return /* binding */ useDashboardStats; },
/* harmony export */   "wc": function() { return /* binding */ QueryKeyDashboard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20414);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50815);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95915);
/* harmony import */ var _useSession__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87627);








var DashboardIntervalValues = [
    "Week",
    "Month",
    "Year",
    "All"
];
var QueryKeyDashboard = "dashboard-stats";
var useDashboardStats = function(interval) {
    var network = (0,_useSession__WEBPACK_IMPORTED_MODULE_1__/* .useSession */ .k)().network;
    var res = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)([
        QueryKeyDashboard,
        network.networkId,
        interval
    ], /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var selectedInterval, res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    selectedInterval = interval.toLowerCase();
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().get("/api/data-dashboard?interval=" + selectedInterval)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    }), (0,_constants__WEBPACK_IMPORTED_MODULE_5__/* .queryOptions */ .C)(false, true));
    var _data;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, res), {
        data: (_data = res.data) !== null && _data !== void 0 ? _data : []
    });
};


/***/ }),

/***/ 36804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99226);
/* harmony import */ var _components_theme_breakpoints__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75550);





var AppGrid = function(param) {
    var children = param.children, sx = param.sx;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            minHeight: "calc(100% - 144px)",
            scrollbarWidth: "none",
            padding: [
                "48px 24px",
                "64px"
            ],
            maxWidth: [
                _components_theme_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .appGridSmBreakpoint */ .EU,
                _components_theme_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .appGridMdBreakpoint */ .zR,
                _components_theme_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .appGridLgBreakpoint */ .pU
            ],
            margin: "auto"
        }, sx),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AppGrid);


/***/ }),

/***/ 24171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ appPageWrapper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./src/components/hooks/useSidebarWidth.ts
var useSidebarWidth = __webpack_require__(33468);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@amplitude/analytics-browser/lib/esm/index.js + 60 modules
var esm = __webpack_require__(56748);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/phosphor-react/dist/icons/ArrowFatLineUp.esm.js
var ArrowFatLineUp_esm = __webpack_require__(85606);
// EXTERNAL MODULE: ./node_modules/phosphor-react/dist/icons/ArrowFatLineDown.esm.js
var ArrowFatLineDown_esm = __webpack_require__(75820);
// EXTERNAL MODULE: ./node_modules/phosphor-react/dist/icons/Bank.esm.js
var Bank_esm = __webpack_require__(6344);
// EXTERNAL MODULE: ./node_modules/phosphor-react/dist/icons/Books.esm.js
var Books_esm = __webpack_require__(15067);
// EXTERNAL MODULE: ./node_modules/phosphor-react/dist/icons/DiscordLogo.esm.js
var DiscordLogo_esm = __webpack_require__(88433);
// EXTERNAL MODULE: ./node_modules/phosphor-react/dist/icons/TwitterLogo.esm.js
var TwitterLogo_esm = __webpack_require__(27842);
// EXTERNAL MODULE: ./node_modules/phosphor-react/dist/icons/MediumLogo.esm.js
var MediumLogo_esm = __webpack_require__(44206);
// EXTERNAL MODULE: ./src/components/hooks/dashboard/useDashboardStats.ts
var useDashboardStats = __webpack_require__(18778);
// EXTERNAL MODULE: ./src/components/hooks/protocol/assets/useAssetPrices.ts + 4 modules
var useAssetPrices = __webpack_require__(10183);
// EXTERNAL MODULE: ./src/components/hooks/protocol/vaults/useAllVaultData.ts
var useAllVaultData = __webpack_require__(90160);
// EXTERNAL MODULE: ./src/components/hooks/utils/useIsMobile.ts
var useIsMobile = __webpack_require__(56490);
// EXTERNAL MODULE: ./src/components/shared/link/index.tsx
var shared_link = __webpack_require__(67113);
// EXTERNAL MODULE: ./src/components/theme/styles/colors.tsx
var colors = __webpack_require__(16381);
// EXTERNAL MODULE: ./src/components/theme/styles/mixins.tsx
var mixins = __webpack_require__(52230);
// EXTERNAL MODULE: ./src/components/types.ts
var types = __webpack_require__(87493);
// EXTERNAL MODULE: ./src/components/utils/utils.tsx
var utils = __webpack_require__(63189);
// EXTERNAL MODULE: ./src/config/types.ts
var config_types = __webpack_require__(87859);
// EXTERNAL MODULE: ./src/v2/components/ui/label/index.tsx
var label = __webpack_require__(45306);
// EXTERNAL MODULE: ./src/v2/components/ui/loadSkeleton/index.tsx
var loadSkeleton = __webpack_require__(66820);
;// CONCATENATED MODULE: ./src/v2/components/layout/footer/index.tsx


















var SystemStatisticsItem = function(param) {
    var stat = param.stat, isLoading = param.isLoading, isIncrease = param.isIncrease, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, {
                sx: {
                    flexDirection: "row-reverse",
                    minWidth: 0,
                    justifyContent: "flex-end",
                    mb: 0.5
                },
                toolTip: {
                    content: "Lorem ipsum",
                    placement: "title"
                },
                labelTitle: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "label3",
                            color: colors/* primaryColors.700 */.w2[700],
                            children: stat
                        }),
                        typeof isIncrease === "boolean" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            sx: {
                                color: colors/* secondaryColors.200 */.St[200],
                                lineHeight: "12px"
                            },
                            children: isIncrease ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowFatLineUp_esm/* default */.Z, {
                                size: 12
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowFatLineDown_esm/* default */.Z, {
                                size: 12
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(loadSkeleton/* LoadSkeleton */.n, {
                isLoading: isLoading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "lead",
                    sx: {
                        color: colors/* primaryColors.100 */.w2[100]
                    },
                    children: children
                })
            })
        ]
    });
};
var SocialLink = function(param) {
    var href = param.href, icon = param.icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_link/* NormalLink */.Yk, {
        onClick: function() {
            esm/* track */.j("footer-link", {
                type: href
            });
        },
        href: href,
        target: "_blank",
        sx: {
            textDecoration: "none",
            "& :hover": {
                color: "white"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
            direction: "row",
            alignItems: "center",
            spacing: 2,
            children: icon
        })
    });
};
var Footer = function() {
    var ref, ref1;
    var computed = (0,useAllVaultData/* useAllVaultData */.V)().computed;
    var ref2 = (0,useAssetPrices/* default */.ZP)(), _data = ref2.data, _market = _data.market, vstPrice = _market.VST, vstaPrice = _market.VSTA, priceLoading = ref2.isLoading;
    var isMobile = (0,useIsMobile/* useIsMobile */.d)();
    var ref3 = (0,useDashboardStats/* useDashboardStats */.f_)("Week"), tmp = ref3.data, stats = tmp === void 0 ? [] : tmp, isDashLoading = ref3.isLoading;
    var ref4;
    var isTvlIncrease = ((ref4 = computed === null || computed === void 0 ? void 0 : computed.totalCollateralUsd) !== null && ref4 !== void 0 ? ref4 : 0) > (Number((ref = stats[stats.length - 1]) === null || ref === void 0 ? void 0 : (ref1 = ref.stats) === null || ref1 === void 0 ? void 0 : ref1.tvl.tvlUsd) || 0);
    var systemStatistics = [
        {
            stat: config_types/* ENativeAsset.VSTA */.tx.VSTA,
            isLoading: priceLoading,
            children: (0,utils/* displayFormatUnits */.Hz)({
                value: vstaPrice,
                displayType: types/* EDisplayType.USD */.co.USD,
                decimal: 3
            })
        },
        {
            stat: config_types/* ENativeAsset.VST */.tx.VST,
            isLoading: priceLoading,
            children: (0,utils/* displayFormatUnits */.Hz)({
                value: vstPrice,
                displayType: types/* EDisplayType.USD */.co.USD,
                decimal: 3
            })
        }, 
    ];
    if (!isMobile) {
        var ref5;
        systemStatistics.push({
            stat: "TOTAL VALUE LOCKED",
            isLoading: !!(computed === null || computed === void 0 ? void 0 : computed.isAnyVaultLoading) || isDashLoading,
            children: (0,utils/* displayFormatUnits */.Hz)({
                value: (ref5 = computed === null || computed === void 0 ? void 0 : computed.totalCollateralUsd) !== null && ref5 !== void 0 ? ref5 : 0,
                displayType: types/* EDisplayType.USD */.co.USD
            }),
            isIncrease: isTvlIncrease
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            padding: [
                "32px",
                "48px 64px"
            ],
            background: colors/* black.15% */.Sn["15%"],
            width: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            container: true,
            sx: {
                alignItems: "center",
                justifyContent: "space-between",
                gap: "32px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    sx: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        flexGrow: [
                            1,
                            0.6
                        ]
                    },
                    children: systemStatistics.map(function(param) {
                        var stat = param.stat, isLoading = param.isLoading, isIncrease = param.isIncrease, children = param.children;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SystemStatisticsItem, {
                            stat: stat,
                            isLoading: isLoading,
                            isIncrease: isIncrease,
                            children: children
                        }, stat);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,mixins/* columnGap */.e$)(8)), {
                        width: [
                            "100%",
                            "fit-content"
                        ]
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "label3",
                            sx: {
                                color: colors/* primaryColors.700 */.w2[700],
                                textAlign: [
                                    "left",
                                    "end"
                                ]
                            },
                            children: "STAY IN THE LOOP"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            sx: {
                                display: "flex",
                                alignItems: "center",
                                gap: "32px",
                                justifyContent: [
                                    "space-between",
                                    undefined
                                ]
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialLink, {
                                    label: "Participate in governance",
                                    href: "https://curia.vestafinance.xyz/",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bank_esm/* default */.Z, {
                                        size: 24,
                                        color: colors/* primaryColors.400 */.w2[400],
                                        weight: "regular"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialLink, {
                                    label: "Docs & Whitepaper",
                                    href: "https://docs.vestafinance.xyz/",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Books_esm/* default */.Z, {
                                        size: 24,
                                        color: colors/* primaryColors.400 */.w2[400],
                                        weight: "regular"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialLink, {
                                    label: "Join our Discord Community!",
                                    href: "https://discord.gg/yNc6Cm638",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscordLogo_esm/* default */.Z, {
                                        size: 24,
                                        color: colors/* primaryColors.400 */.w2[400],
                                        weight: "fill"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialLink, {
                                    label: "Follow us on Twitter!",
                                    href: "https://twitter.com/vestafinance",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(TwitterLogo_esm/* default */.Z, {
                                        size: 24,
                                        color: colors/* primaryColors.400 */.w2[400],
                                        weight: "fill"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialLink, {
                                    label: "Subscribe to our Medium!",
                                    href: "https://medium.com/@VestaFinance",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(MediumLogo_esm/* default */.Z, {
                                        size: 24,
                                        color: colors/* primaryColors.400 */.w2[400],
                                        weight: "fill"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/v2/components/ui/appPageWrapper/index.tsx






var AppPageWrapper = function(param) {
    var children = param.children, sx = param.sx;
    var sidebarWidth = (0,useSidebarWidth/* useSidebarWidth */.O)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: (0,_object_spread/* default */.Z)({
            minHeight: "100vh",
            position: "absolute",
            top: [
                "88px",
                0
            ],
            left: [
                0,
                sidebarWidth
            ],
            right: 0,
            transition: "left 0.15s linear",
            height: "100%"
        }, sx),
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
        ]
    });
};
/* harmony default export */ var appPageWrapper = (AppPageWrapper);


/***/ }),

/***/ 34138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ TextBlock; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/phosphor-react/dist/icons/CaretLeft.esm.js
var CaretLeft_esm = __webpack_require__(75357);
// EXTERNAL MODULE: ./node_modules/phosphor-react/dist/icons/SquaresFour.esm.js
var SquaresFour_esm = __webpack_require__(74506);
// EXTERNAL MODULE: ./node_modules/phosphor-react/dist/icons/ArrowsLeftRight.esm.js
var ArrowsLeftRight_esm = __webpack_require__(92007);
// EXTERNAL MODULE: ./src/components/shared/link/index.tsx
var shared_link = __webpack_require__(67113);
// EXTERNAL MODULE: ./src/components/theme/styles/colors.tsx
var colors = __webpack_require__(16381);
// EXTERNAL MODULE: ./src/components/theme/styles/mixins.tsx
var mixins = __webpack_require__(52230);
// EXTERNAL MODULE: ./src/config/types.ts
var types = __webpack_require__(87859);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/phosphor-react/dist/icons/CaretRight.esm.js
var CaretRight_esm = __webpack_require__(37114);
;// CONCATENATED MODULE: ./src/v2/components/ui/breadcrumbs/pageTitleBreadcrumbs.tsx







var navigationExclusions = [
    "stability",
    "liquidity",
    "v2",
    ""
];
function getPaths(fullPath) {
    var reconstructedPath = "";
    var splitPath = fullPath.split("/");
    return splitPath.map(function(path, index) {
        var lastPath = reconstructedPath;
        reconstructedPath += "".concat(path).concat(splitPath.length - 1 > index ? "/" : "");
        return navigationExclusions.includes(path) ? {
            text: path,
            href: lastPath,
            isNavigatable: false
        } : {
            text: path,
            href: reconstructedPath,
            isNavigatable: true
        };
    });
}
function sanitize(lp) {
    return lp.replaceAll("_", " ");
}
var PageTitleBreadcrumbs = function() {
    var router = (0,next_router.useRouter)();
    var paths = (0,react.useMemo)(function() {
        return getPaths(router.asPath);
    }, [
        router.asPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        container: true,
        sx: {
            gap: "8px",
            alignItems: "center"
        },
        children: paths.map(function(param, index) {
            var text = param.text, href = param.href, isNavigatable = param.isNavigatable;
            return isNavigatable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_link/* default */.ZP, {
                href: href,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    sx: {
                        display: "flex",
                        alignItems: "center",
                        gap: "8px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "label3",
                            sx: {
                                color: index === paths.length - 1 ? colors/* primaryColors.400 */.w2[400] : colors/* primaryColors.700 */.w2[700],
                                transition: "color 0.05s linear",
                                "&:hover": {
                                    color: isNavigatable ? colors/* primaryColors.400 */.w2[400] : colors/* primaryColors.700 */.w2[700],
                                    cursor: index === paths.length - 1 ? "default" : "pointer"
                                }
                            },
                            children: sanitize(text.toUpperCase())
                        }),
                        index !== paths.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CaretRight_esm/* default */.Z, {
                            color: colors/* primaryColors.700 */.w2[700],
                            size: 16
                        })
                    ]
                })
            }, text) : null;
        })
    });
};

// EXTERNAL MODULE: ./src/v2/components/ui/icons/assets/index.tsx
var assets = __webpack_require__(66023);
// EXTERNAL MODULE: ./src/v2/components/ui/icons/vesta/index.tsx
var vesta = __webpack_require__(77435);
;// CONCATENATED MODULE: ./src/v2/components/ui/textBlock/index.tsx












var TextBlock = function(param) {
    var id = param.id, _variant = param.variant, variant = _variant === void 0 ? "main" : _variant, primaryText = param.primaryText, secondaryText = param.secondaryText, descriptionText = param.descriptionText, breadcrumbProps = param.breadcrumbProps;
    if (variant === "secondary") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            id: id,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h5",
                    sx: {
                        color: colors/* primaryColors.100 */.w2[100]
                    },
                    children: primaryText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body2",
                    sx: {
                        color: colors/* primaryColors.100 */.w2[100],
                        marginTop: "16px"
                    },
                    children: secondaryText
                })
            ]
        });
    }
    if (variant === "subsection") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            id: id,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h6",
                    sx: {
                        color: colors/* primaryColors.400 */.w2[400]
                    },
                    children: primaryText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body3",
                    sx: {
                        color: colors/* primaryColors.700 */.w2[700],
                        marginTop: "8px"
                    },
                    children: secondaryText
                })
            ]
        });
    }
    if ([
        "vault",
        "stability",
        "collectibles",
        "staking"
    ].includes(variant)) {
        var getIcon = function() {
            switch(variant){
                case "vault":
                    return vesta/* VestaIcons.VAULT */.wb.VAULT;
                case "stability":
                    return vesta/* VestaIcons.BADGE */.wb.BADGE;
                case "collectibles":
                    return vesta/* VestaIcons.RECEIPT */.wb.RECEIPT;
                case "staking":
                    return vesta/* VestaIcons.COIN */.wb.COIN;
                default:
                    return vesta/* VestaIcons.LOCK */.wb.LOCK;
            }
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            id: id,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    gap: "16px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(vesta/* VestaIcon */.QA, {
                        icon: getIcon()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "label2",
                                sx: {
                                    color: colors/* primaryColors.100 */.w2[100]
                                },
                                children: primaryText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body3",
                                sx: {
                                    color: colors/* primaryColors.100 */.w2[100]
                                },
                                children: secondaryText
                            })
                        ]
                    })
                ]
            })
        });
    }
    if (variant === "arrow") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            id: id,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    sx: {
                        display: "flex",
                        alignItems: "center",
                        gap: "16px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CaretLeft_esm/* default */.Z, {
                            size: 20
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h6",
                            sx: {
                                color: colors/* primaryColors.100 */.w2[100]
                            },
                            children: primaryText
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body3",
                    sx: {
                        color: colors/* primaryColors.100 */.w2[100],
                        marginTop: "8px"
                    },
                    children: secondaryText
                })
            ]
        });
    }
    if (variant === "vst") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            id: id,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    gap: "16px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            borderRadius: "3px",
                            padding: "12px",
                            height: "48px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(assets/* AssetIcon */.Y, {
                            asset: types/* ENativeAsset.VST */.tx.VST,
                            size: 24
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h6",
                                sx: {
                                    color: colors/* primaryColors.100 */.w2[100]
                                },
                                children: primaryText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body3",
                                sx: {
                                    color: colors/* primaryColors.100 */.w2[100]
                                },
                                children: secondaryText
                            })
                        ]
                    })
                ]
            })
        });
    }
    if (variant === "boxlist") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            id: id,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    gap: "16px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            borderRadius: "3px",
                            padding: "12px",
                            height: "48px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SquaresFour_esm/* default */.Z, {
                            size: 24,
                            color: colors/* primaryColors.100 */.w2[100]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h6",
                                sx: {
                                    color: colors/* primaryColors.100 */.w2[100]
                                },
                                children: primaryText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body3",
                                sx: {
                                    color: colors/* primaryColors.100 */.w2[100]
                                },
                                children: secondaryText
                            })
                        ]
                    })
                ]
            })
        });
    }
    if (variant === "switch") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            id: id,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    gap: "16px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mixins/* defaultBorder */.gM), {
                            borderRadius: "3px",
                            padding: "12px",
                            height: "48px"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsLeftRight_esm/* default */.Z, {
                            size: 24
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h6",
                                sx: {
                                    color: colors/* primaryColors.100 */.w2[100]
                                },
                                children: primaryText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body3",
                                sx: {
                                    color: colors/* primaryColors.100 */.w2[100]
                                },
                                children: secondaryText
                            })
                        ]
                    })
                ]
            })
        });
    }
    if (variant === "breadcrumbs") {
        var previous = breadcrumbProps.previous;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            id: id,
            sx: {
                display: "flex",
                flexDirection: "column",
                gap: "8px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_link/* default */.ZP, {
                    href: previous,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            gap: "8px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CaretLeft_esm/* default */.Z, {
                                color: colors/* primaryColors.700 */.w2[700],
                                size: 16
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "label3",
                                sx: {
                                    color: colors/* primaryColors.700 */.w2[700],
                                    transition: "color 0.05s ease",
                                    "&:hover": {
                                        color: colors/* primaryColors.100 */.w2[100]
                                    }
                                },
                                children: "RETURN"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h5",
                    sx: {
                        color: colors/* primaryColors.100 */.w2[100]
                    },
                    children: primaryText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitleBreadcrumbs, {})
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        id: id,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h5",
                sx: {
                    color: colors/* primaryColors.100 */.w2[100]
                },
                children: primaryText
            }),
            secondaryText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                sx: {
                    color: colors/* primaryColors.400 */.w2[400],
                    marginTop: "32px"
                },
                children: secondaryText
            }),
            descriptionText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body3",
                sx: {
                    color: colors/* primaryColors.700 */.w2[700],
                    marginTop: "8px"
                },
                children: descriptionText
            })
        ]
    });
};


/***/ })

}]);